<details #details>
  <summary
    #summary
    [attr.aria-controls]="id() + '-content'"
    [attr.aria-expanded]="expanded()"
    [id]="id() + '-header'"
    (click)="toggleAccordion($event)"
  >
    <opac-icon *ngIf="iconPosition === 'start'" class="marker-icon start" [icon]="iconName()"></opac-icon>

    <div class="content-wrapper">
      <span>
        {{ title }}
        <ng-content select="[slot='content-title']"></ng-content>
      </span>

      <ng-content select="[slot='content-end']"></ng-content>
    </div>

    <ng-content select="[slot='end']"></ng-content>
    <opac-icon *ngIf="iconPosition === 'end'" class="marker-icon end" [icon]="iconName()"></opac-icon>
  </summary>

  <div
    #content
    [attr.aria-labelledby]="id() + '-header'"
    class="content"
    [id]="id() + '-content'"
    role="region"
  >
    <ng-content></ng-content>
  </div>
</details>
